/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import { createSelector } from 'reselect';
import { treatments as Treatments } from './constants';

export const flags = getterFromKeyPath(['features', 'flags']);
export const loading = getterFromKeyPath(['features', 'loading']);

export const getFlag = (featureName: string) =>
  createSelector(
    flags,
    treatments => {
      return treatments.get(featureName);
    }
  );

export const getFlagTreatment = (featureName: string) =>
  createSelector(
    getFlag(featureName),
    flag => {
      return flag.get('treatment');
    }
  );

export const getFlagConfig = (featureName: string) =>
  createSelector(
    getFlag(featureName),
    flag => {
      return flag.get('config');
    }
  );

export const isFeatureEnabled = (featureName: string) =>
  createSelector(
    getFlagTreatment(featureName),
    (featureTreatment) => featureTreatment === Treatments.ON,
  );

export const isFeatureDisabled = (featureName: string) =>
  createSelector(
    getFlagTreatment(featureName),
    (featureTreatment) => featureTreatment === Treatments.OFF,
  );



// WEBPACK FOOTER //
// ./src/app/modules/features/getters.js